import React from 'react'
import _ from 'lodash'

// App content
import clearBraces from '../assets/invisalign/1_ClearBraces.jpg'
import braces from '../assets/invisalign/2_Braces.jpg'
import invisalign from '../assets/invisalign/3_Invisalign.jpg'

// App utils
import { themeStyles, presets } from '../utils/theme'

const images = [clearBraces, braces, invisalign]

const styles = {
  image: {
    maxHeight: '40vw',
    maxWidth: '40vw',
    [presets.Mobile]: {
      maxWidth: '200px',
      maxHeight: '200px',
    },
  },
  unselected: {
    opacity: '0.5',
    display: 'none',
    [presets.Tablet]: {
      display: 'block',
    },
  },
}

class BracesExamples extends React.Component {
  render() {
    const imageElements = images.map((image, index) => (
      <img
        css={[
          styles.image,
          _.includes(this.props.selectedIndexs, index) ? {} : styles.unselected,
        ]}
        key={index}
        src={image}
      />
    ))
    return (
      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
          width: '100%',
          maxWidth: '800px',
          margin: '0 auto',
          ...themeStyles.elementMargin,
        }}
      >
        {imageElements}
      </div>
    )
  }
}

export default BracesExamples
